import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";
// import "./css/base.scss";

const VetsMicroBanner = () => {
    const {clientAssetsLink} = useClientConfig();

    return (
        <div className="vets-micro-banner-wrapper">
            <div className="content-wrapper">
                <img src={clientAssetsLink + "/Logo-300x67.png"} alt="logo" className="logo" />
                <h1>{"JOIN AUSTRALIA & NEW ZEALAND'S leading VETERINARY Partner"}</h1>
                <p>We are looking for qualified vets like you to join our incredible network of clinics</p>
            </div>
            <img src={clientAssetsLink + "/comesaygday-home-header2.jpg"} alt="Banner" />
        </div>
    );
};

export default VetsMicroBanner;